import React from 'react';
import { Platform } from 'react-native';

// Import SVGs as URLs for web
import serceSvg from '@/assets/serce.svg';
import lokacjaSvg from '@/assets/lokacja.svg';
import gotowkaSvg from '@/assets/gotowka.svg';

// Promo section shown on auth screens (web only)
export const WebPromoSection: React.FC = () => {
  if (Platform.OS !== 'web') return null;

  return (
    <div style={styles.container}>
      {/* Main heading */}
      <h1 style={styles.heading}>
        Spotkanie, które pozostaje w pamięci
      </h1>
      
      {/* Subtitle */}
      <p style={styles.subtitle}>
        Poznawaj nowych ludzi, umów się na spotkania i ciesz się wspólnym czasem
      </p>
      
      {/* Feature cards */}
      <div style={styles.features}>
        <div style={styles.featureCard}>
          <div style={styles.featureIcon}>
            <img src={serceSvg as string} width={32} height={32} alt="" />
          </div>
          <h3 style={styles.featureTitle}>Bezpieczny czat</h3>
          <p style={styles.featureDescription}>
            Rozmawiaj w bezpiecznym środowisku
          </p>
        </div>
        
        <div style={styles.featureCard}>
          <div style={styles.featureIcon}>
            <img src={lokacjaSvg as string} width={32} height={32} alt="" />
          </div>
          <h3 style={styles.featureTitle}>Spotkania w pobliżu</h3>
          <p style={styles.featureDescription}>
            Znajdź ludzi w Twojej okolicy
          </p>
        </div>
        
        <div style={styles.featureCard}>
          <div style={styles.featureIcon}>
            <img src={gotowkaSvg as string} width={32} height={32} alt="" />
          </div>
          <h3 style={styles.featureTitle}>Bezpieczne płatności</h3>
          <p style={styles.featureDescription}>
            System weryfikacji i płatności
          </p>
        </div>
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    padding: '40px',
    maxWidth: '95%',
  },
  logo: {
    fontSize: '28px',
    fontWeight: 700,
    background: 'linear-gradient(135deg, #9C5879 0%, #6EC5DB 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    marginBottom: '32px',
  },
  heading: {
    fontSize: '36px',
    fontWeight: 700,
    color: '#ffffff',
    lineHeight: 1.2,
    marginBottom: '16px',
    margin: 0,
  },
  subtitle: {
    fontSize: '16px',
    color: '#ffffff',
    lineHeight: 1.6,
    marginBottom: '40px',
    margin: '0 0 40px 0',
  },
  features: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  featureCard: {
    backgroundColor: 'rgba(186, 132, 156, 0.25)',
    backdropFilter: 'blur(10px)',
    borderRadius: '16px',
    padding: '24px',
    textAlign: 'center' as const,
    boxShadow: '0 8px 20px rgba(0, 0, 0, 0.15)',
  },
  featureIcon: {
    marginBottom: '12px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  featureTitle: {
    fontSize: '18px',
    fontWeight: 600,
    color: '#ffffff',
    marginBottom: '8px',
    margin: '0 0 8px 0',
  },
  featureDescription: {
    fontSize: '14px',
    color: '#ffffff',
    margin: 0,
  },
};
